import React from "react";
import { Grid, Box } from '@mui/material';
import RsDataField from "./RsDataField";
import { IRegistrationSheet } from "../../models/registrationModels";
import GridItemContainer from "../layout/GridItemContainer";
import NumberChip from "../layout/NumberChip";
import { FontSize, useThemeStore } from "../../stores/ThemeStore";

const chipFontSizeMapping = {
    [FontSize.Small]: 14,
    [FontSize.Big]: 18,
  };


const RsSummary = ({ registrationSheet }: { registrationSheet: IRegistrationSheet }) => {
    const {currentFontSize} = useThemeStore()
    return (
        <Grid container px={2} spacing={3}>
            <GridItemContainer xs={6} md={3} value={registrationSheet.arrival}>
                <RsDataField labelStrong="ANKUNFT" labelSmall="(arrival)" value={registrationSheet.arrival.toFormattedDateOrDefault()} />
            </GridItemContainer>

            <GridItemContainer xs={6} md={3} value={registrationSheet.departure}>
                <RsDataField labelStrong="GEPLANTE ABREISE" labelSmall="(planned departure)" value={registrationSheet.departure.toFormattedDateOrDefault()} />
            </GridItemContainer>

            <GridItemContainer xs={6} md={3} value="">
                <RsDataField labelStrong="ABREISE" labelSmall="(departure)" value="" />
            </GridItemContainer>

            <Grid item xs={6} md={3}>
                <Box display="flex" flexWrap="wrap" gap={1} >
                    <NumberChip label="Personen gesamt" count={registrationSheet.personsTotal} style={{fontSize: chipFontSizeMapping[currentFontSize]}}/>
                    <NumberChip label="Pflichtig" count={registrationSheet.personsTaxBound} style={{fontSize: chipFontSizeMapping[currentFontSize]}}/>
                    <NumberChip label="Frei" count={registrationSheet.personsFree} style={{fontSize: chipFontSizeMapping[currentFontSize]}}/>
                </Box>
            </Grid>
        </Grid >
    );
};

export default RsSummary;
